import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useScreeningApi() {
  const callApi = useApiCall();

  const addFeedback = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SCREENING.ADD_FEEDBACK, data, onSuccess, onError, true);
  };

  const getHistory = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SCREENING.GET_HISTORY, data, onSuccess, onError, true);
  };

  const updateStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SCREENING.UPDATE_STATUS, data, onSuccess, onError, true);
  };

  return {
    callAddFeedback: addFeedback,
    callGetHistory: getHistory,
    callUpdateStatus: updateStatus,
  };
}
